export default "__VITE_ASSET__tE761jr$__"